import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const StatusAbortIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M16.5299 7.47C16.2399 7.18 15.7599 7.18 15.4699 7.47L11.9999 10.94L8.52994 7.47C8.23994 7.18 7.75994 7.18 7.46994 7.47C7.17994 7.76 7.17994 8.24 7.46994 8.53L10.9399 12L7.46994 15.47C7.17994 15.76 7.17994 16.24 7.46994 16.53C7.75994 16.82 8.23994 16.82 8.52994 16.53L11.9999 13.06L15.4699 16.53C15.7599 16.82 16.2399 16.82 16.5299 16.53C16.8199 16.24 16.8199 15.76 16.5299 15.47L13.0599 12L16.5299 8.53C16.8199 8.24 16.8199 7.76 16.5299 7.47Z"
        fill={color}
      />
      <path
        d="M12 0.25C5.52 0.25 0.25 5.52 0.25 12C0.25 18.48 5.52 23.75 12 23.75C18.48 23.75 23.75 18.48 23.75 12C23.75 5.52 18.48 0.25 12 0.25ZM12 22.25C6.35 22.25 1.75 17.65 1.75 12C1.75 6.35 6.35 1.75 12 1.75C17.65 1.75 22.25 6.35 22.25 12C22.25 17.65 17.65 22.25 12 22.25Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

StatusAbortIcon.displayName = 'StatusAbortIcon';
